// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalFilter_root__13oHz","footer":"ModalFilter_footer__3Oubu"};